<!-- results-table.component.html -->
<h1 mat-dialog-title>{{this.estructura.nombre}}</h1>
<div mat-dialog-content>
  <button mat-icon-button (click)="addNewRootItem()"><mat-icon>add</mat-icon></button>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
      <button mat-icon-button disabled></button>
      {{node.nombre}}
      <button mat-icon-button (click)="addNewItem(node)"><mat-icon>add_circle_outline</mat-icon></button>
      <button mat-icon-button (click)="editItem(node)"><mat-icon>edit</mat-icon></button>
      <button mat-icon-button (click)="selectNode(node)" *ngIf="node.valor.id!=null"><mat-icon>swap_horiz</mat-icon></button>
      <button mat-icon-button (click)="removeItem(node)"><mat-icon>delete</mat-icon></button>
    </mat-tree-node>
	  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.nombre">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      {{node.nombre}}
      <button mat-icon-button (click)="addNewItem(node)" ><mat-icon>add_circle_outline</mat-icon></button>
      <button mat-icon-button (click)="editItem(node)"><mat-icon>edit</mat-icon></button>
      <button mat-icon-button (click)="selectNode(node)" *ngIf="node.valor.id!=null"><mat-icon>swap_horiz</mat-icon></button>
      <button mat-icon-button (click)="removeItem(node)"><mat-icon>delete</mat-icon></button>
    </mat-tree-node>
  </mat-tree>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">Confirmar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
